// supports jira assets or elements connect
export const getMappedFieldValue = (data) => {
  if (!data) return null;

  if (Array.isArray(data))
    return data.length > 0 ? data[0].value : null;

  if (data.values)
    return data.values.join(', ');

  return data.value;
}